import * as t from 'io-ts';
import { either, right } from 'fp-ts/Either';
import isUUID from 'validator/lib/isUUID';
// represents a UUID from an string
export const UUID = new t.Type('UUID', (u) => typeof u === 'string' && isUUID(u, 4), (u, context) => either.chain(t.string.validate(u, context), (s) => {
    return isUUID(s, 4) ? right(s) : t.failure(u, context);
}), (uuid) => uuid);
//# sourceMappingURL=uuid.js.map